import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.classes),
    style: _normalizeStyle($options.styles)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 6 /* CLASS, STYLE */))
}